// Single source of truth for order maths on the client (server re-validates everything).
export const DEPOSIT_TERMS =
  'Your booking deposit secures your project in our schedule. Need to cancel? Contact us as soon as possible. Your statutory rights are not affected.';

export const REFUND_POLICY = [
  'Your booking deposit secures your project in our schedule. If you need to cancel, please contact Visual Creationz as soon as possible.',
  'Refunds and any deductions for work already completed will be assessed in accordance with our terms and applicable UK consumer law. Your statutory rights are not affected.',
  'Production times are estimates. If your order is delayed, we will keep you informed and provide an updated completion estimate. If we cannot resolve a significant delay, you may be entitled to a refund or other remedy under applicable law.',
];

export const REFUND_POLICY_LINK = '/terms-conditions#refunds';

export const PACKAGE_DEPOSITS = { basic: 20, standard: 30, premium: 50 };

export const ADDON_PRICES = { rush: 15, revision: 5, song: 20 };

export const SONG_ADDON = {
  name: 'Personalised Song: Your Story, Your Song',
  price: ADDON_PRICES.song,
  description:
    'Add an original song inspired by your special occasion, personal memories and the people who matter most.',
};

export const EMPTY_SONG_DETAILS = { names: '', occasion: '', memories: '', genre: '', mood: '', language: '' };

export const computeOrder = (pkg, form) => {
  if (!pkg) return { packagePrice: 0, addons: [], total: 0, deposit: 0, remaining: 0 };
  const addons = [];
  if (form.rushDelivery) addons.push({ id: 'rush', label: 'Priority Delivery (24hrs)', amount: ADDON_PRICES.rush });
  if (form.extraRevisions > 0)
    addons.push({ id: 'revision', label: `Additional Revisions (${form.extraRevisions})`, amount: form.extraRevisions * ADDON_PRICES.revision });
  if (form.personalisedSong) addons.push({ id: 'song', label: SONG_ADDON.name, amount: ADDON_PRICES.song });
  const packagePrice = Number(pkg.price) || 0;
  const total = packagePrice + addons.reduce((sum, a) => sum + a.amount, 0);
  const deposit = PACKAGE_DEPOSITS[(pkg.id || '').toLowerCase()] ?? Math.min(20, packagePrice);
  return { packagePrice, addons, total, deposit, remaining: Math.max(total - deposit, 0) };
};

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;
